const numberToEnglish = (num, region) => {
    if (region === "IN") {
        return numberToEnglishAsia(num);
    }
    else {
        return numberToEnglishAbroad(num);
    }
};

const numberToEnglishAsia = (num) => {
    
    var a = ['', 'one ', 'two ', 'three ', 'four ', 'five ', 'six ', 'seven ', 'eight ', 'nine ', 'ten ', 'eleven ', 'twelve ', 'thirteen ', 'fourteen ', 'fifteen ', 'sixteen ', 'seventeen ', 'eighteen ', 'nineteen '];
    var b = ['', '', 'twenty', 'thirty', 'forty', 'fifty', 'sixty', 'seventy', 'eighty', 'ninety'];

    let decimal = num.toString().split('.').length > 1 ? num.toString().split('.')[1] : "";
    let n = ('000000000' + num.split('.')[0]).substr(-9).match(/^(\d{2})(\d{2})(\d{2})(\d{1})(\d{2})$/);
    if (!n) return; var str = '';
    str += (Number(n[1]) !== 0) ? (a[Number(n[1])] || b[n[1][0]] + ' ' + a[n[1][1]]) + 'crore ' : '';
    str += (Number(n[2]) !== 0) ? (a[Number(n[2])] || b[n[2][0]] + ' ' + a[n[2][1]]) + 'lakh ' : '';
    str += (Number(n[3]) !== 0) ? (a[Number(n[3])] || b[n[3][0]] + ' ' + a[n[3][1]]) + 'thousand ' : '';
    str += (Number(n[4]) !== 0) ? (a[Number(n[4])] || b[n[4][0]] + ' ' + a[n[4][1]]) + 'hundred ' : '';
    str += (Number(n[5]) !== 0) ? ((str !== '') ? 'and ' : '') + (a[Number(n[5])] || b[n[5][0]] + ' ' + a[n[5][1]]) : '';

    if (decimal.length > 0) {
        let DecimalNumber = Number(decimal);
        str += (DecimalNumber !== 0 ? " and " + b[Number(decimal[0])] : "") + " " + (DecimalNumber !== 0 ? a[Number(decimal[1])] : "") + (DecimalNumber !== 0 ? " Paise" : "");
    }

    str += " only";

    return str;
};

const numberToEnglishAbroad = (s) => {
    var th = ['', 'thousand', 'million', 'billion', 'trillion'];
    var dg = ['zero', 'one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine'];
    var tn = ['ten', 'eleven', 'twelve', 'thirteen', 'fourteen', 'fifteen', 'sixteen', 'seventeen', 'eighteen', 'nineteen'];
    var tw = ['twenty', 'thirty', 'forty', 'fifty', 'sixty', 'seventy', 'eighty', 'ninety'];

    s = s.toString();
    // eslint-disable-next-line
    s = s.replace(/[\, ]/g, '');
    // eslint-disable-next-line
    if (s != parseFloat(s)) return 'not a number';
    var x = s.indexOf('.');
    // eslint-disable-next-line
    if (x == -1)
        x = s.length;
    if (x > 15)
        return 'too big';
    var n = s.split('');
    var str = '';
    var sk = 0;
    for (var i = 0; i < x; i++) {
        // eslint-disable-next-line
        if ((x - i) % 3 == 2) {
            // eslint-disable-next-line
            if (n[i] == '1') {
                str += tn[Number(n[i + 1])] + ' ';
                i++;
                sk = 1;
            } 
            // eslint-disable-next-line
            else if (n[i] != 0) {
                str += tw[n[i] - 2] + ' ';
                sk = 1;
            }
        }
        // eslint-disable-next-line
        else if (n[i] != 0) { // 0235
            str += dg[n[i]] + ' ';
            // eslint-disable-next-line
            if ((x - i) % 3 == 0) str += 'hundred ';
            sk = 1;
        }
        if ((x - i) % 3 === 1) {
            if (sk)
                str += th[(x - i - 1) / 3] + ' ';
            sk = 0;
        }
    }

    if (x !== s.length) {
        var y = s.length;
        var counter = 0, decimalData = "";
        // eslint-disable-next-line
        for (var i = x + 1; i < y; i++) {
            if (dg[n[i]] !== "zero") {
                counter++;
                decimalData += dg[n[i]] + ' ';
            }
        }

        if (counter > 0) {
            str += 'and ' + decimalData
        }
    }
    return str.replace(/\s+/g, ' ');
};

export default numberToEnglish;